import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { TokenType } from 'interfaces';

export type Device = {
  device_id?: number;
  admin_id?: number;
  user_id?: number;
  push_token?: { [key: string]: string };
  type?: (typeof TokenType)[keyof typeof TokenType];
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Device
   * --
   */
  getDevices: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_DEVICE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Device
   * --
   */
  getDevice: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_DEVICE, { device_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Device
   * --
   */
  createDevice: async (body: Device) => {
    try {
      const res = await $http.post(APIConstant.CREATE_DEVICE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Device
   * --
   */
  updateDevice: async (body: Device) => {
    try {
      const { device_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_DEVICE, {
        device_id: device_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Device
   * --
   */
  deleteDevice: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_DEVICE, {
        device_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
